import { render, staticRenderFns } from "./FullscreenErrorMessage.vue?vue&type=template&id=5dd50f6e"
import script from "./FullscreenErrorMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullscreenErrorMessage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports